// extracted by mini-css-extract-plugin
export default {"harmony":"YQGc9E"};